var _path, _circle, _path2, _polygon, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnrollNowTrane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.9855 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Enroll Now") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "EnrollNowPrimaryTrane",
    d: "M12.5067,11.3033c.3884-.404.9246-.6323,1.485-.6323s1.0966.2283,1.485.6323c.3537.3637.5428.8564.5233,1.3633,0,.1733-.16,1.0233-.2533,1.5167-.1667.88-.7133,1.8167-1.7467,1.8167s-1.5933-.9767-1.7433-1.8133c-.0933-.4967-.2567-1.3467-.2567-1.52-.0282-.5042.1555-.9972.5067-1.36v-.0033ZM11.6,14.3033c.2567,1.4367,1.2,2.3633,2.4,2.3633s2.1267-.9033,2.4-2.3567c.0433-.22.2533-1.3333.2633-1.6133.0318-.6914-.2226-1.3654-.7033-1.8633-.5165-.5343-1.2288-.8346-1.9719-.8315-.7431.0032-1.4528.3095-1.9648.8481-.4768.4941-.7268,1.1643-.69,1.85.02.2767.2433,1.4733.2667,1.6033ZM14,23.3333c-2.0201.0007-3.9504-.8342-5.3333-2.3067v-.0833c0-1,.7967-1.5367,1.5267-1.72l3.8067-.7167,3.8033.71c.4733.15,1.53.6133,1.53,1.7233v.0867c-1.3829,1.4725-3.3133,2.3073-5.3333,2.3067ZM14,8.6667c2.7616.0023,5.2878,1.5558,6.5358,4.0194,1.248,2.4636,1.0061,5.4193-.6258,7.6472-.2433-.8-.91-1.4433-1.91-1.76l-4-.7467-3.95.7433c-.9263.1857-1.6777.8617-1.96,1.7633-1.6319-2.2279-1.8737-5.1837-.6258-7.6472,1.248-2.4636,3.7741-4.0171,6.5358-4.0194ZM14,8c-4.4183,0-8,3.5817-8,8s3.5817,8,8,8,8-3.5817,8-8c0-2.1217-.8428-4.1566-2.3431-5.6568-1.5003-1.5003-3.5351-2.3432-5.6569-2.3432Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "EnrollNowGreen",
    cx: 31.5,
    cy: 41.5,
    r: 7.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "EnrollNowPrimaryTrane",
    d: "M23.0089,44.6424c-.5359.0705-1.0786.1195-1.6339.1195H2.25V2.2381h31.5v30.2143c0,.0961-.0123.1891-.0145.2847.7803.1993,1.5209.4948,2.2053.882.0309-.3859.0592-.7728.0592-1.1666V0H0v47h21.375c.937,0,1.8504-.0963,2.7384-.2638-.4558-.6411-.8266-1.344-1.1045-2.0938Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "EnrollNow",
    points: "35.4707 38.2521 34.558 37.7438 31.1558 43.6479 28.2559 40.7969 27.5129 41.5295 31.3878 45.3395 35.4707 38.2521"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "EnrollNowAdvantageTrane",
    x: 6.1273,
    y: 37.3233,
    width: 13.5691,
    height: 2.3556
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "EnrollNowAdvantageTrane",
    x: 6.1273,
    y: 32.3233,
    width: 19,
    height: 2.3556
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "EnrollNowAdvantageTrane",
    x: 6.1273,
    y: 27.3233,
    width: 23,
    height: 2.3556
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrollNowTrane);
export default __webpack_public_path__ + "static/media/enroll-now-trane.5a34664c7b57e5676bcb86330ce15f4c.svg";
export { ForwardRef as ReactComponent };